import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock } from '../../commonComponents/CommonComponents'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function FictitiousMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId

  const personSummary = queueCachesState.personsCache[personId]
  const personLabels = queueCachesState.labelsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]
  let aiScores = messageDetails?.aiScores
  if (typeof aiScores === 'string') {
    try {
      aiScores = JSON.parse(aiScores)
    } catch {
      aiScores = null
    }
  }
  const aiCategory = aiScores?.categoryScores?.find((category) => category.personType === aiScores?.personType)

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchPersonLabels(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(personLabels) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      {/* Row */}
      {personSummary?.birth && (
        <Grid>
          <Cell columns={6}>
            <DataBlock heading={t('birthPlace', 'Birth Place')} data={personSummary?.birth?.value?.place?.original} />
          </Cell>
          <Cell columns={6}>
            <DataBlock heading={t('birthDate', 'Birth Date')} data={personSummary?.birth?.value?.date?.original} />
          </Cell>
        </Grid>
      )}

      {/* Row */}
      {personSummary?.death && (
        <Grid>
          <Cell columns={6}>
            <DataBlock heading={t('deathPlace', 'Death Place')} data={personSummary?.death?.value?.place?.original} />
          </Cell>
          <Cell columns={6}>
            <DataBlock heading={t('deathDate', 'Death Date')} data={personSummary?.death?.value?.date?.original} />
          </Cell>
        </Grid>
      )}

      {/* Row */}
      {personSummary?.burial && (
        <Grid>
          <Cell columns={6}>
            <DataBlock
              heading={t('burialPlace', 'Burial Place')}
              data={personSummary?.burial?.value?.place?.original}
            />
          </Cell>
          <Cell columns={6}>
            <DataBlock heading={t('burialDate', 'Burial Date')} data={personSummary?.burial?.value?.date?.original} />
          </Cell>
        </Grid>
      )}

      {/* Row */}
      <Cell columns={6}>
        {messageDetails?.fictitiousTerm && (
          <DataBlock heading={t('queues.fictionalTerm', 'Fictional Term')} data={messageDetails?.fictitiousTerm} />
        )}
        {messageDetails?.term && <DataBlock heading={t('queues.term', 'Term')} data={messageDetails?.term} />}
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('queues.fictionalName', 'Fictional Name')} data={messageDetails?.name} />
      </Cell>

      {/* Row */}
      {aiScores && (
        <Cell columns={12}>
          <DataBlock
            heading={t('queues.aiCategoryScore', 'AI Category Score')}
            data={t(`queues.aiCategoryScore.${aiScores?.personType}`, '{type}: {score}', {
              type: aiCategory?.personType,
              score: aiCategory?.value ? Math.floor((aiCategory.value * 100) / 5) * 5 : 0,
            })}
          />
        </Cell>
      )}

      {/* Row */}
      <LabelsBlock personLabels={personLabels} />
    </Grid>
  )
}
